export const translations = {
  da: {
    // App
    appName: "MediTrack",
    
    // Auth
    welcome: "Velkommen",
    createAccount: "Opret konto",
    login: "Log ind",
    logout: "Log ud",
    enterPin: "Indtast PIN",
    confirmPin: "Bekræft PIN",
    name: "Navn",
    email: "Email",
    pin: "PIN-kode",
    pinMustBe4: "PIN skal være 4 cifre",
    pinsDontMatch: "PIN-koder matcher ikke",
    forgotPin: "Glemt PIN?",
    resetPin: "Nulstil PIN",
    enterResetCode: "Indtast nulstillingskode",
    newPin: "Ny PIN",
    sendResetCode: "Send kode",
    confirmReset: "Bekræft",
    switchUser: "Skift bruger",
    loginWithEmail: "Log ind med email",
    knownAccounts: "Kendte konti",
    savedAccounts: "Gemte brugere",
    removeAccount: "Fjern",
    loginAs: "Log ind som",
    otherAccount: "Anden konto",
    rememberUser: "Gem bruger",
    
    // Navigation
    dashboard: "Oversigt",
    medicines: "Medicin",
    schedule: "Skema",
    settings: "Indstillinger",
    
    // Dashboard
    todaySchedule: "Dagens skema",
    weekOverview: "Ugeoversigt",
    noMedicineToday: "Ingen medicin planlagt i dag",
    taken: "Taget",
    notTaken: "Ikke taget",
    markAsTaken: "Marker som taget",
    undo: "Fortryd",
    
    // Medicines
    myMedicines: "Mine lægemidler",
    addMedicine: "Tilføj medicin",
    editMedicine: "Rediger medicin",
    medicineName: "Navn",
    dosage: "Dosis",
    stockCount: "Antal på lager",
    pillsWhole: "Hele piller",
    pillsHalf: "Halve piller",
    reminderDays: "Påmindelse dage før",
    daysUntilEmpty: "dage til tom",
    lowStock: "Lavt lager",
    orderSoon: "Bestil snart",
    stockOk: "Lager OK",
    noMedicines: "Ingen medicin tilføjet",
    deleteMedicine: "Slet medicin",
    confirmDelete: "Er du sikker?",
    discontinueConfirm: "skal seponeres?",
    discontinue: "Seponer",
    addStock: "Tilføj antal",
    amount: "Antal",
    startDate: "Startdato",
    cancelDate: "Annulér dato",
    endDate: "Slutdato",
    repeatInterval: "Gentag",
    daily: "Hver dag",
    weekly: "Hver uge",
    monthly: "Hver måned",
    specialOrdination: "Special ordination",
    biweekly: "Hver 14. dag",
    ordStartDate: "Startdato",
    ordEndDate: "Slutdato (valgfri)",
    ordRepeat: "Gentages",
    ordActive: "Aktiv ordination",
    ordFrom: "Fra",
    ordTo: "Til",
    ordSelectTimeOfDay: "Vælg tidspunkt på dagen",
    
    // Schedule
    weeklySchedule: "Ugentligt skema",
    addToSchedule: "Tilføj til skema",
    selectMedicine: "Vælg medicin",
    selectTimeSlot: "Vælg tidspunkt",
    selectDays: "Vælg dage",
    noSchedule: "Intet skema oprettet",
    
    // Time slots
    timeSlots: "Tidspunkter",
    morning: "Morgen",
    noon: "Middag",
    evening: "Aften",
    night: "Nat",
    
    // Days
    monday: "Mandag",
    tuesday: "Tirsdag",
    wednesday: "Onsdag",
    thursday: "Torsdag",
    friday: "Fredag",
    saturday: "Lørdag",
    sunday: "Søndag",
    mon: "Man",
    tue: "Tir",
    wed: "Ons",
    thu: "Tor",
    fri: "Fre",
    sat: "Lør",
    sun: "Søn",
    
    // Settings
    language: "Sprog",
    danish: "Dansk",
    english: "Engelsk",
    profile: "Profil",
    notifications: "Notifikationer",
    
    // Common
    save: "Gem",
    cancel: "Annuller",
    delete: "Slet",
    edit: "Rediger",
    add: "Tilføj",
    back: "Tilbage",
    loading: "Indlæser...",
    error: "Fejl",
    success: "Succes",
    pills: "piller",
    piller: "Piller",
    stk: "Stk",
    enheder: "Enheder",
    unitLabel: "Enhed",
    days: "dage",
  },
  
  en: {
    // App
    appName: "MediTrack",
    
    // Auth
    welcome: "Welcome",
    createAccount: "Create Account",
    login: "Log In",
    logout: "Log Out",
    enterPin: "Enter PIN",
    confirmPin: "Confirm PIN",
    name: "Name",
    email: "Email",
    pin: "PIN Code",
    pinMustBe4: "PIN must be 4 digits",
    pinsDontMatch: "PINs don't match",
    forgotPin: "Forgot PIN?",
    resetPin: "Reset PIN",
    enterResetCode: "Enter reset code",
    newPin: "New PIN",
    sendResetCode: "Send Code",
    confirmReset: "Confirm",
    switchUser: "Switch User",
    loginWithEmail: "Log in with email",
    knownAccounts: "Known Accounts",
    savedAccounts: "Saved Users",
    removeAccount: "Remove",
    loginAs: "Log in as",
    otherAccount: "Other Account",
    rememberUser: "Remember user",
    
    // Navigation
    dashboard: "Dashboard",
    medicines: "Medicines",
    schedule: "Schedule",
    settings: "Settings",
    
    // Dashboard
    todaySchedule: "Today's Schedule",
    weekOverview: "Week Overview",
    noMedicineToday: "No medicine scheduled today",
    taken: "Taken",
    notTaken: "Not taken",
    markAsTaken: "Mark as taken",
    undo: "Undo",
    
    // Medicines
    myMedicines: "My Medicines",
    addMedicine: "Add Medicine",
    editMedicine: "Edit Medicine",
    medicineName: "Name",
    dosage: "Dosage",
    stockCount: "Stock Count",
    pillsWhole: "Whole Pills",
    pillsHalf: "Half Pills",
    reminderDays: "Reminder Days Before",
    daysUntilEmpty: "days until empty",
    lowStock: "Low stock",
    orderSoon: "Order soon",
    stockOk: "Stock OK",
    noMedicines: "No medicines added",
    deleteMedicine: "Delete Medicine",
    confirmDelete: "Are you sure?",
    discontinueConfirm: "will be discontinued?",
    discontinue: "Discontinue",
    addStock: "Add Stock",
    amount: "Amount",
    startDate: "Start Date",
    cancelDate: "Cancel Date",
    endDate: "End Date",
    repeatInterval: "Repeat",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    specialOrdination: "Special Ordination",
    biweekly: "Every 14 days",
    ordStartDate: "Start date",
    ordEndDate: "End date (optional)",
    ordRepeat: "Repeat",
    ordActive: "Active ordination",
    ordFrom: "From",
    ordTo: "To",
    ordSelectTimeOfDay: "Select time of day",
    
    // Schedule
    weeklySchedule: "Weekly Schedule",
    addToSchedule: "Add to Schedule",
    selectMedicine: "Select Medicine",
    selectTimeSlot: "Select Time Slot",
    selectDays: "Select Days",
    noSchedule: "No schedule created",
    
    // Time slots
    timeSlots: "Time Slots",
    morning: "Morning",
    noon: "Noon",
    evening: "Evening",
    night: "Night",
    
    // Days
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    
    // Settings
    language: "Language",
    danish: "Danish",
    english: "English",
    profile: "Profile",
    notifications: "Notifications",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    back: "Back",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    pills: "pills",
    piller: "Pills",
    stk: "Pcs",
    enheder: "Units",
    unitLabel: "Unit",
    days: "days",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
